export default "__VITE_ASSET__818cbc9a__"